import { useEffect, useState } from 'react';
import { loadSchema } from '../schemaLoader';

/**
 * useProductSchema: Loads the published schema for a product type.
 *
 * Shared by ProductListingPage and TradeEntryPage so the load / loading /
 * not-found handling lives in one place. A failed load resolves to
 * `schema: null`, which the pages render as "Product Not Found".
 */
const useProductSchema = (productType) => {
  const [schema, setSchema] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    setIsLoading(true);

    loadSchema(productType)
      .then((loadedSchema) => {
        if (isMounted) {
          setSchema(loadedSchema);
        }
      })
      .catch(() => {
        if (isMounted) {
          setSchema(null);
        }
      })
      .finally(() => {
        if (isMounted) {
          setIsLoading(false);
        }
      });

    return () => {
      isMounted = false;
    };
  }, [productType]);

  return { schema, isLoading };
};

export default useProductSchema;
